import ClipboardJS from 'clipboard'

$(function () {
    var clipboard = new ClipboardJS('.btn-clipboard');
    clipboard.on('success', function (e) {
        var trigger = $(e.trigger);
        trigger.find(".bi-clipboard").removeClass("bi-clipboard").addClass("bi-check-lg");
        setTimeout(function () {
            trigger.find(".bi-check-lg").removeClass("bi-check-lg").addClass("bi-clipboard");
            e.clearSelection();
        }, 2000);
    });
})